<template>
  <div :class="$style.ctn">
    <ul :class="$style.lists">
      <li v-for="(list, index) in lists" :key="index" :style="getColorStyle(list.type)">
        <h3 :class="$style.listTitle">
          {{ list.name }}
        </h3>

        <ul v-if="list.values.length" :class="$style.listValues">
          <li v-for="(sub, jindex) in list.values" :key="jindex" :class="$style.listValue">
            <h4 :class="$style.listSubTile">
              {{ sub.name }}
            </h4>
            <ul :class="[$style.listSubValues, com.list]">
              <li v-for="(value, key) in sub.values" :key="key">
                {{ value }}
              </li>
            </ul>
          </li>
        </ul>
        <div v-else :class="[$style.noData]">
          {{ list.noData }}
        </div>
      </li>
    </ul>
    <TipMessage :class="$style.tipMessage" :full-report-link-at-end="true">
      Find more information about signature artifacts and mapping to MITRE ATT&CK™ MATRIX at the
    </TipMessage>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { ColorMap } from '../common/style';
import TipMessage from './TipMessage.vue';

export default defineComponent({
  components: { TipMessage },
  inject: ['root'],
  computed: {
    lists() {
      return this.root.behaviorActivities;
    },
  },
  methods: {
    getColorStyle(type) {
      return `--activities-accent-color: var(${ColorMap[type]})`;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding: 20px 10px 0;
}

.noData {
  color: #3f4757bd;
  text-align: left;
  font-size: 13px;
  margin-top: 12px;
}

ul.lists {
  list-style: none;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  grid-gap: 20px;

  @media screen and (max-width: 920px) {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: initial;
  }

  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
    grid-auto-flow: initial;
  }
}

.tipMessage {
  margin-top: 20px;
}

.listTitle {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.02em;
  color: rgba(63, 71, 87, 0.7);
  padding-bottom: 2px;
  border-bottom: 2px solid var(--activities-accent-color);

  & + ul.listValues {
    margin-top: 12px;
  }

  @media print {
    border-bottom: 2px solid #989898;
  }
}

ul.listValues {
  list-style: none;
  overflow-wrap: anywhere;
}

li.listValue {
  & + li.listValue {
    margin-top: 12px;
  }
}

.listSubTile {
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.02em;

  color: rgba(63, 71, 87, 0.85);

  & + ul.listSubValues {
    margin-top: 6px;
  }
}

ul.listSubValues {
  & > li + li {
    margin-top: 6px;
  }
}
</style>
<style lang="scss" src="./common.module.scss" module="com"></style>
